var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 28,
    viewBox: "0 0 194 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M188.492 6.9668C190.174 6.9668 191.509 7.47637 192.495 8.4955C193.498 9.51464 194 10.9301 194 12.7419V20.6524H189.875V13.3C189.875 12.4265 189.64 11.7551 189.171 11.286C188.718 10.8007 188.087 10.558 187.278 10.558C186.47 10.558 185.831 10.8007 185.361 11.286C184.909 11.7551 184.682 12.4265 184.682 13.3V20.6524H180.557V13.3C180.557 12.4265 180.322 11.7551 179.853 11.286C179.4 10.8007 178.769 10.558 177.961 10.558C177.152 10.558 176.513 10.8007 176.044 11.286C175.591 11.7551 175.364 12.4265 175.364 13.3V20.6524H171.215V7.11239H175.364V8.81095C175.785 8.24476 176.335 7.7999 177.014 7.47637C177.694 7.13665 178.462 6.9668 179.319 6.9668C180.339 6.9668 181.244 7.18518 182.037 7.62196C182.846 8.05873 183.477 8.68154 183.93 9.49038C184.399 8.74625 185.038 8.13961 185.847 7.67049C186.656 7.20136 187.537 6.9668 188.492 6.9668Z",
    fill: "url(#paint0_linear_427_332)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M169.026 13.6637C169.026 14.0519 169.002 14.4564 168.953 14.877H159.563C159.627 15.7182 159.894 16.3652 160.363 16.8182C160.849 17.2549 161.439 17.4733 162.135 17.4733C163.17 17.4733 163.89 17.0366 164.294 16.163H168.711C168.484 17.0527 168.072 17.8535 167.473 18.5653C166.891 19.277 166.155 19.8352 165.265 20.2396C164.375 20.644 163.38 20.8462 162.28 20.8462C160.954 20.8462 159.773 20.5631 158.738 19.9969C157.702 19.4307 156.893 18.6219 156.311 17.5704C155.729 16.5189 155.438 15.2895 155.438 13.8821C155.438 12.4747 155.721 11.2453 156.287 10.1938C156.869 9.14228 157.678 8.33344 158.713 7.76725C159.749 7.20106 160.938 6.91797 162.28 6.91797C163.591 6.91797 164.755 7.19298 165.774 7.74299C166.794 8.293 167.586 9.07757 168.152 10.0967C168.735 11.1159 169.026 12.3048 169.026 13.6637ZM164.78 12.5718C164.78 11.86 164.537 11.2938 164.052 10.8732C163.566 10.4526 162.96 10.2423 162.232 10.2423C161.536 10.2423 160.946 10.4445 160.46 10.8489C159.991 11.2534 159.7 11.8276 159.587 12.5718H164.78Z",
    fill: "url(#paint1_linear_427_332)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.952 17.134V20.6525H151.84C150.336 20.6525 149.163 20.2885 148.322 19.5606C147.481 18.8164 147.06 17.6113 147.06 15.9451V10.5582H145.41V7.11252H147.06V3.8125H151.21V7.11252H153.927V10.5582H151.21V15.9936C151.21 16.398 151.307 16.6892 151.501 16.8671C151.695 17.0451 152.018 17.134 152.471 17.134H153.952Z",
    fill: "url(#paint2_linear_427_332)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M138.381 20.8462C137.2 20.8462 136.148 20.644 135.226 20.2396C134.304 19.8352 133.576 19.2851 133.042 18.5895C132.509 17.8778 132.209 17.0851 132.145 16.2115H136.245C136.294 16.6807 136.512 17.0608 136.901 17.352C137.289 17.6432 137.766 17.7888 138.332 17.7888C138.85 17.7888 139.246 17.6917 139.521 17.4976C139.812 17.2873 139.958 17.0204 139.958 16.6968C139.958 16.3086 139.756 16.0255 139.351 15.8476C138.947 15.6534 138.292 15.4431 137.386 15.2167C136.415 14.9902 135.606 14.7556 134.959 14.513C134.312 14.2542 133.754 13.8578 133.285 13.324C132.816 12.774 132.581 12.0379 132.581 11.1159C132.581 10.3394 132.792 9.63567 133.212 9.00478C133.649 8.35771 134.28 7.84814 135.105 7.47607C135.946 7.104 136.941 6.91797 138.09 6.91797C139.788 6.91797 141.123 7.33857 142.093 8.17976C143.08 9.02095 143.646 10.1372 143.792 11.5284H139.958C139.893 11.0592 139.683 10.6872 139.327 10.4122C138.987 10.1372 138.534 9.99965 137.968 9.99965C137.483 9.99965 137.111 10.0967 136.852 10.2908C136.593 10.4688 136.464 10.7195 136.464 11.0431C136.464 11.4313 136.666 11.7225 137.07 11.9166C137.491 12.1107 138.138 12.3048 139.012 12.499C140.015 12.7578 140.831 13.0166 141.462 13.2755C142.093 13.5181 142.643 13.9225 143.112 14.4887C143.598 15.0387 143.848 15.7829 143.865 16.7211C143.865 17.5138 143.638 18.2256 143.185 18.8565C142.748 19.4712 142.109 19.9565 141.268 20.3124C140.443 20.6683 139.481 20.8462 138.381 20.8462Z",
    fill: "url(#paint3_linear_427_332)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M131.373 7.11523L122.881 27.0855H118.416L121.522 20.1942L116.014 7.11523H120.648L123.778 15.5838L126.884 7.11523H131.373Z",
    fill: "url(#paint4_linear_427_332)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.776 20.8217C107.53 20.8217 106.414 20.6195 105.427 20.215C104.44 19.8106 103.648 19.2121 103.049 18.4194C102.467 17.6268 102.159 16.6723 102.127 15.5561H106.543C106.608 16.187 106.826 16.6723 107.198 17.012C107.57 17.3356 108.056 17.4973 108.654 17.4973C109.269 17.4973 109.754 17.3598 110.11 17.0848C110.466 16.7937 110.644 16.3973 110.644 15.8958C110.644 15.4752 110.498 15.1274 110.207 14.8524C109.932 14.5774 109.584 14.351 109.164 14.173C108.759 13.9951 108.177 13.7929 107.417 13.5664C106.317 13.2267 105.419 12.887 104.723 12.5472C104.028 12.2075 103.429 11.706 102.928 11.0428C102.426 10.3795 102.175 9.51408 102.175 8.44642C102.175 6.86109 102.75 5.62356 103.898 4.73385C105.047 3.82795 106.543 3.375 108.387 3.375C110.264 3.375 111.776 3.82795 112.925 4.73385C114.074 5.62356 114.688 6.86918 114.769 8.47068H110.28C110.248 7.92067 110.045 7.49198 109.673 7.18462C109.301 6.86109 108.824 6.69932 108.242 6.69932C107.74 6.69932 107.336 6.83682 107.029 7.11183C106.721 7.37066 106.567 7.75081 106.567 8.25229C106.567 8.80231 106.826 9.23099 107.344 9.53835C107.862 9.84571 108.67 10.1773 109.771 10.5332C110.871 10.9053 111.76 11.2612 112.44 11.6009C113.135 11.9406 113.734 12.434 114.235 13.0811C114.737 13.7281 114.988 14.5612 114.988 15.5804C114.988 16.551 114.737 17.4326 114.235 18.2253C113.75 19.018 113.038 19.6489 112.1 20.118C111.162 20.5871 110.054 20.8217 108.776 20.8217Z",
    fill: "url(#paint5_linear_427_332)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1817 20.8462C86.8552 20.8462 85.6582 20.5631 84.5905 19.9969C83.539 19.4307 82.7059 18.6219 82.0912 17.5704C81.4926 16.5189 81.1934 15.2895 81.1934 13.8821C81.1934 12.4909 81.5007 11.2695 82.1154 10.218C82.7302 9.15037 83.5713 8.33344 84.639 7.76725C85.7067 7.20106 86.9038 6.91797 88.2303 6.91797C89.5568 6.91797 90.7539 7.20106 91.8215 7.76725C92.8892 8.33344 93.7304 9.15037 94.3451 10.218C94.9598 11.2695 95.2672 12.4909 95.2672 13.8821C95.2672 15.2733 94.9517 16.5027 94.3208 17.5704C93.7061 18.6219 92.8568 19.4307 91.773 19.9969C90.7053 20.5631 89.5082 20.8462 88.1817 20.8462ZM88.1817 17.255C88.9744 17.255 89.6457 16.9638 90.1958 16.3814C90.7619 15.799 91.045 14.9659 91.045 13.8821C91.045 12.7982 90.77 11.9651 90.22 11.3828C89.6862 10.8004 89.0229 10.5092 88.2303 10.5092C87.4214 10.5092 86.7501 10.8004 86.2163 11.3828C85.6824 11.949 85.4155 12.7821 85.4155 13.8821C85.4155 14.9659 85.6743 15.799 86.192 16.3814C86.7258 16.9638 87.3891 17.255 88.1817 17.255Z",
    fill: "url(#paint6_linear_427_332)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M69.7021 9.03049C70.0903 8.39959 70.6484 7.89002 71.3764 7.50178C72.1043 7.11353 72.9375 6.91941 73.8757 6.91941C74.9919 6.91941 76.003 7.20251 76.9089 7.76869C77.8148 8.33488 78.5265 9.14372 79.0442 10.1952C79.578 11.2467 79.8449 12.4681 79.8449 13.8593C79.8449 15.2505 79.578 16.4799 79.0442 17.5476C78.5265 18.5991 77.8148 19.416 76.9089 19.9984C76.003 20.5645 74.9919 20.8476 73.8757 20.8476C72.9213 20.8476 72.0882 20.6616 71.3764 20.2895C70.6646 19.9013 70.1065 19.3917 69.7021 18.7608V20.6535H65.5527V2.69727H69.7021V9.03049ZM75.6228 13.8593C75.6228 12.8239 75.3316 12.0151 74.7492 11.4327C74.1831 10.8342 73.4794 10.5349 72.6382 10.5349C71.8132 10.5349 71.1095 10.8342 70.5271 11.4327C69.9609 12.0313 69.6778 12.8482 69.6778 13.8835C69.6778 14.9188 69.9609 15.7358 70.5271 16.3343C71.1095 16.9329 71.8132 17.2321 72.6382 17.2321C73.4632 17.2321 74.1669 16.9329 74.7492 16.3343C75.3316 15.7196 75.6228 14.8946 75.6228 13.8593Z",
    fill: "url(#paint7_linear_427_332)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.362 13.6637C63.362 14.0519 63.3377 14.4564 63.2892 14.877H53.8985C53.9632 15.7182 54.2301 16.3652 54.6993 16.8182C55.1846 17.2549 55.775 17.4733 56.4706 17.4733C57.506 17.4733 58.2258 17.0366 58.6302 16.163H63.0465C62.82 17.0527 62.4075 17.8535 61.809 18.5653C61.2266 19.277 60.4906 19.8352 59.6008 20.2396C58.7111 20.644 57.7163 20.8462 56.6162 20.8462C55.2897 20.8462 54.1088 20.5631 53.0735 19.9969C52.0382 19.4307 51.2293 18.6219 50.647 17.5704C50.0646 16.5189 49.7734 15.2895 49.7734 13.8821C49.7734 12.4747 50.0565 11.2453 50.6227 10.1938C51.2051 9.14228 52.0139 8.33344 53.0492 7.76725C54.0846 7.20106 55.2736 6.91797 56.6162 6.91797C57.9265 6.91797 59.0913 7.19298 60.1104 7.74299C61.1296 8.293 61.9222 9.07757 62.4884 10.0967C63.0708 11.1159 63.362 12.3048 63.362 13.6637ZM59.1155 12.5718C59.1155 11.86 58.8729 11.2938 58.3876 10.8732C57.9023 10.4526 57.2956 10.2423 56.5677 10.2423C55.8721 10.2423 55.2816 10.4445 54.7963 10.8489C54.3272 11.2534 54.036 11.8276 53.9228 12.5718H59.1155Z",
    fill: "url(#paint8_linear_427_332)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5921 20.6514H43.4427L36.5029 10.1445V20.6514H32.3535V3.61719H36.5029L43.4427 14.1726V3.61719H47.5921V20.6514Z",
    fill: "url(#paint9_linear_427_332)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95975 0H0V22.9171L22.9171 0H16.3383L4.71386 11.4843V5.18998L9.95975 0Z",
    fill: "url(#paint10_linear_427_332)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0066 18.1563L6.33854 22.9171H22.9171V6.14557L18.2491 10.8148V18.1563H11.0066Z",
    fill: "url(#paint11_linear_427_332)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_332",
    x1: 30.2164,
    y1: 11.8897,
    x2: 196.029,
    y2: 11.8897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_332",
    x1: 30.2168,
    y1: 11.8896,
    x2: 196.029,
    y2: 11.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_332",
    x1: 30.2178,
    y1: 11.8903,
    x2: 196.03,
    y2: 11.8903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_427_332",
    x1: 30.2158,
    y1: 11.8896,
    x2: 196.028,
    y2: 11.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_427_332",
    x1: 30.2171,
    y1: 11.8927,
    x2: 196.029,
    y2: 11.8927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_427_332",
    x1: 30.2159,
    y1: 11.8892,
    x2: 196.028,
    y2: 11.8892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_427_332",
    x1: 30.2143,
    y1: 11.8896,
    x2: 196.027,
    y2: 11.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_427_332",
    x1: 30.2172,
    y1: 11.8908,
    x2: 196.029,
    y2: 11.8908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_427_332",
    x1: 30.2158,
    y1: 11.8896,
    x2: 196.028,
    y2: 11.8896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_427_332",
    x1: 30.2168,
    y1: 11.8892,
    x2: 196.029,
    y2: 11.8892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9049F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.731862,
    stopColor: "#7A1CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#39E8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_427_332",
    x1: 11.4586,
    y1: 0,
    x2: 11.4586,
    y2: 22.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_427_332",
    x1: 11.4586,
    y1: 0,
    x2: 11.4586,
    y2: 22.9171,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F47F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.490385,
    stopColor: "#8027FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40D2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e77bf3297522cbc4ed59d1ecd28797ea.svg";
export { ForwardRef as ReactComponent };